import { LinearProgress, styled } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
/**
 * Custom Progress bar control.
 * @param props @see ProgressBarProps
 */
export function ProgressBar({ id, className, alignment, backgroundColor, barColor, progress, total, style, completeText }) {
    const classes = {
        root: "progress-bar-root",
        bar: "progress-bar-bar",
        completeText: "progress-bar-complete-text",
        percentTextLeft: "progress-bar-percent-left",
        percentTextRight: "progress-bar-percent-right",
        primaryBar: "progress-bar-primary-bar"
    };
    const StyledDiv = styled("div")(({ theme }) => ({
        [`& .${classes.root}`]: { width: "100%", borderRadius: 3 },
        [`& .${classes.bar}`]: {
            borderRadius: 3,
            backgroundColor: backgroundColor ?? theme.palette.controls.progressBar.backgroundColor,
            height: 6
        },
        [`& .${classes.completeText}`]: {
            marginLeft: alignment == "left" ? "7px" : "0px",
            marginBottom: "3px",
            fontSize: "0.8125rem"
        },
        [`& .${classes.percentTextLeft}`]: {
            marginLeft: "0px",
            display: alignment == "left" ? "inline-block" : "none",
            fontSize: "1rem",
            marginBottom: "3px"
        },
        [`& .${classes.percentTextRight}`]: {
            marginLeft: "7px",
            display: alignment == "right" ? "inline-block" : "none",
            fontSize: "1rem",
            marginBottom: "3px"
        },
        [`& .${classes.primaryBar}`]: {
            backgroundColor: barColor ?? theme.palette.controls.progressBar.barColor
        }
    }));
    const percent = total == 0 ? 100 : Math.trunc((progress / total) * 100);
    return (React.createElement(StyledDiv, { id: id, className: (classes.root, className), style: style },
        React.createElement(Box, { sx: { minWidth: 35, textAlign: alignment } },
            React.createElement(Typography, { "data-testid": "progress-bar-percent-left", display: alignment === "right" ? "none" : "inline-block", className: classes.percentTextLeft, color: "text.primary" }, `${percent}%`),
            React.createElement(Typography, { "data-testid": "progress-bar-complete-count", display: "inline-block", className: classes.completeText, color: "text.secondary" }, `${progress}/${total} ${completeText}`),
            React.createElement(Typography, { "data-testid": "progress-bar-percent-right", display: alignment === "left" ? "none" : "inline-block", className: classes.percentTextRight, color: "text.primary" }, `${percent}%`)),
        React.createElement(LinearProgress, { classes: { barColorPrimary: classes.primaryBar }, className: classes.bar, variant: "determinate", value: percent })));
}
//Prop defaults
ProgressBar.defaultProps = {
    completeText: "Complete",
    alignment: "left"
};
